import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { MfaInterface } from '../models/mfa.interface';

@Injectable()
export class MsisdnMissionService {

  constructor(private apiService: ApiService) {}

  /**
   * Update mission
   */
  update(object: any, procedureCode: string, mfa: MfaInterface|null = null): Observable<any> {
    if (mfa) {
      object = Object.assign({ action: mfa.action, code: mfa.code, destination: mfa.destination }, object);
    }
    return this.apiService.put('msisdn/mission/' + procedureCode, object);
  }

  /**
   * Save mission
   */
  save(object: any, procedureCode: string, mfa: MfaInterface|null = null): Observable<any> {
    if (mfa) {
      object = Object.assign({ action: mfa.action, code: mfa.code, destination: mfa.destination }, object);
    }
    return this.apiService.post('msisdn/mission/' + procedureCode, object);
  }
}
